import { useEffect, useState } from "react";
import { Gem, Trash2, Upload } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function StoneSetsPage() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({ title: "", description: "", file: null });
  const load = () => api.get("/stone-sets").then(({ data }) => setItems(data)).catch((error) => toast.error(formatApiError(error)));
  useEffect(() => { load(); }, []);

  const submit = async (event) => {
    event.preventDefault();
    if (!form.file) return toast.error("Bir ürün görseli seçin");
    setBusy(true);
    try {
      const payload = new FormData();
      payload.append("file", form.file);
      payload.append("title", form.title);
      payload.append("description", form.description);
      await api.post("/stone-sets", payload, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Doğal taş meditasyon seti yayınlandı");
      setForm({ title: "", description: "", file: null });
      event.target.reset();
      await load();
    } catch (error) {
      toast.error(formatApiError(error));
    } finally {
      setBusy(false);
    }
  };

  const remove = async (item) => {
    if (!window.confirm(`“${item.title}” silinsin mi?`)) return;
    try {
      await api.delete(`/stone-sets/${item.id}`);
      setItems((current) => current.filter((row) => row.id !== item.id));
      toast.success("Set kaldırıldı");
    } catch (error) {
      toast.error(formatApiError(error));
    }
  };

  return (
    <div className="max-w-[1100px] p-3 pb-20 sm:p-5 lg:p-6">
      <div className="mb-5 flex items-center gap-3">
        <div className="grid h-10 w-10 place-items-center bg-pleiades-blue text-white"><Gem size={18} /></div>
        <div><h1 className="text-xl font-semibold">Doğal Taş Meditasyon Setleri</h1><p className="mt-1 text-[12px] text-pleiades-slate">Şeref Tolga Kuralay tarafından kişiye özel hazırlanan setleri yayınlayın.</p></div>
      </div>
      <form onSubmit={submit} className="mb-5 border border-pleiades-border bg-white p-4 sm:p-5">
        <label className="block"><span className="label">Setin adı</span><input className="input" required maxLength={160} value={form.title} onChange={(event) => setForm({ ...form, title: event.target.value })} /></label>
        <label className="mt-4 block"><span className="label">Açıklama</span><textarea className="input resize-y py-3" rows={5} maxLength={3000} required value={form.description} onChange={(event) => setForm({ ...form, description: event.target.value })} /></label>
        <div className="mt-4 grid gap-3 sm:grid-cols-[1fr_auto] sm:items-end">
          <label className="block"><span className="label">Ürün görseli · JPG, PNG veya WebP · en fazla 8 MB</span><input type="file" required accept="image/jpeg,image/png,image/webp" onChange={(event) => setForm({ ...form, file: event.target.files?.[0] || null })} /></label>
          <button disabled={busy} className="flex min-h-11 items-center justify-center gap-2 bg-pleiades-blue px-5 text-[12px] text-white disabled:opacity-50"><Upload size={15} />{busy ? "Yayınlanıyor…" : "Yükle ve yayınla"}</button>
        </div>
      </form>
      <section className="border border-pleiades-border bg-white">
        <h2 className="border-b border-pleiades-border px-5 py-4 text-[13px] font-semibold">Yayınlanan setler · {items.length}</h2>
        {items.length ? items.map((item) => (
          <article key={item.id} className="flex gap-4 border-b border-pleiades-border p-4 last:border-b-0">
            <img src={item.image_url} alt="" className="h-20 w-20 shrink-0 border border-pleiades-border object-cover" />
            <div className="min-w-0 flex-1"><h3 className="text-[14px] font-semibold">{item.title}</h3><p className="mt-1 line-clamp-3 text-[11px] leading-relaxed text-pleiades-slate">{item.description}</p></div>
            <button type="button" aria-label="Seti sil" onClick={() => remove(item)} className="grid h-9 w-9 place-items-center text-pleiades-muted hover:text-red-700"><Trash2 size={16} /></button>
          </article>
        )) : <p className="p-10 text-center text-[12px] text-pleiades-muted">Henüz set yayınlanmadı.</p>}
      </section>
    </div>
  );
}
